export const GET_COLLABORATORS_BY_CONTROL_TOWER_ID = `
  query GetCollaboratorsByControlTowerId($controlTowerId: String!) {
    getCollaboratorsByControlTowerId(controlTowerId: $controlTowerId) {
      _id
      collaboratorType
      controlTowerId
      email
      firstName
      userId
      lastName
      role
      verified
      orgData {
        orgId
      }
    }
  }
`;

export const GET_COLLABORATORS_BY_CONTROL_TOWER_ID_WITH_PAGINATION = `
  query GetCollaboratorsByControlTowerIdWithPagination($input: GetCollaboratorsPaginatedInput!) {
    getCollaboratorsByControlTowerIdWithPagination(input: $input) {
      items {
        _id
        collaboratorType
        controlTowerId
        email
        firstName
        userId
        lastName
        profilePhoto
        role
        orgData {
          orgId
          orgName
          shortCode
          tickerCode
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        pageSize
        total
      }
    }
  }
`;

export const FIND_ACTUAL_SERVICES_BY_CONTROL_TOWER_ID = `
  query FindActualServicesByControlTowerId($controlTowerId: ID!) {
    findActualServicesByControlTowerId(controlTowerId: $controlTowerId) {
      _id
      controlTowerId
      plannedServiceId
      serviceId
    }
  }
`;

export const GET_INTERNAL_USERS = `query GetInternalUsers($getUserByOrgIdInput: GetUsersByOrgIdDto!) {
  getUsersByOrgIdWithFilters(getUserByOrgIdInput: $getUserByOrgIdInput) {
      _id
      firstName
      lastName
      email
      photo
    }
  }`;

export const GET_EXTERNAL_USERS = `query GetUsersNotRelatedToOrgIdWithFilters($getUserByOrgIdInput: GetUsersByOrgIdDto!, $limit: Int!, $offset: Int!, $searchKey: String!) {
  getUsersNotRelatedToOrgIdWithFilters(getUserByOrgIdInput: $getUserByOrgIdInput, limit: $limit, offset: $offset, searchKey: $searchKey) {
    items {
      _id
      firstName
      lastName
      email
      orgId
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      pageSize
      total
    }
  }
}`;

export const REMOVE_COLLABORATOR = `
  mutation RemoveCollaborator($removeCollaboratorInput: RemoveCollaboratorInput!) {
    removeCollaborator(removeCollaboratorInput: $removeCollaboratorInput) {
      _id
      firstName
      lastName
    }
  }
`;

// New invitation queries and mutations
export const INVITE_GUEST_COLLABORATOR = `
  mutation InviteGuestCollaborator($inviteGuestCollaboratorInput: InviteGuestCollaboratorInput!) {
    inviteGuestCollaborator(inviteGuestCollaboratorInput: $inviteGuestCollaboratorInput) {
      _id
      email
      name
      phoneNumber
      role
      collaboratorType
      controlTowerId
      orgId
      invitedByUserId
      targetUserId
      status
      message
      jobRefId
      createdAt
      updatedAt
    }
  }
`;

export const GET_COLLABORATOR_INVITATIONS = `
  query GetCollaboratorInvitations($controlTowerId: String, $status: String) {
    getCollaboratorInvitations(controlTowerId: $controlTowerId, status: $status) {
      _id
      email
      name
      phoneNumber
      role
      collaboratorType
      controlTowerId
      orgId
      invitedByUserId
      targetUserId
      status
      message
      jobRefId
      createdAt
      updatedAt
    }
  }
`;

export const CANCEL_COLLABORATOR_INVITATION = `
  mutation CancelCollaboratorInvitation($invitationId: String!) {
    cancelCollaboratorInvitation(invitationId: $invitationId) {
      _id
      status
    }
  }
`;

export const DELETE_COLLABORATOR_INVITATION = `
  mutation DeleteCollaboratorInvitation($invitationId: String!) {
    deleteCollaboratorInvitation(invitationId: $invitationId) {
      _id
      status
    }
  }
`;

export const RESEND_COLLABORATOR_INVITATION = `
  mutation ResendCollaboratorInvitation($invitationId: String!) {
    resendCollaboratorInvitation(invitationId: $invitationId) {
      _id
      status
      email
      name
      collaboratorType
      updatedAt
    }
  }
`;

// Bulk invitation mutations
export const INVITE_MULTIPLE_COLLABORATORS = `
  mutation InviteMultipleCollaborators($inviteMultipleCollaboratorsInput: InviteMultipleCollaboratorsInput!) {
    inviteMultipleCollaborators(inviteMultipleCollaboratorsInput: $inviteMultipleCollaboratorsInput) {
      _id
      email
      name
      phoneNumber
      role
      collaboratorType
      orgId
      invitedByUserId
      targetUserId
      status
      message
      jobRefId
      createdAt
      updatedAt
    }
  }
`;

export const INVITE_MULTIPLE_GUEST_COLLABORATORS = `
  mutation InviteMultipleGuestCollaborators($inviteMultipleGuestCollaboratorsInput: InviteMultipleGuestCollaboratorsInput!) {
    inviteMultipleGuestCollaborators(inviteMultipleGuestCollaboratorsInput: $inviteMultipleGuestCollaboratorsInput) {
      _id
      email
      name
      phoneNumber
      role
      collaboratorType
      controlTowerId
      orgId
      invitedByUserId
      targetUserId
      status
      message
      jobRefId
      createdAt
      updatedAt
    }
  }
`;

export const FIND_ACTUAL_SERVICES_BY_CONTROL_TOWER_ID_WITH_STATUS_COUNTS_QUERY = `
  query ActualServicesByControlTowerIdOrParentControlTowerIdWithStatusCounts($filter: ActualServiceFilterByControlTowerIdFilterInput!) {
    actualServicesByControlTowerIdOrParentControlTowerIdWithStatusCounts(filter: $filter) {
      services {
        _id
        completedPercentage
        confirmationCount
        endDate
        plannedServiceId
        serviceId
        serviceName
        serviceOptionId
        shipmentId
        smartContractId
        status
      }
      statusCounts {
        pending
        ongoing
        completed
        all
      }
    }
  }
`;

export const GET_COLLABORATOR_BY_USER_ID_AND_CONTROL_TOWER_ID = `
  query GetCollaboratorByUserIdAndControlTowerId($userId: String!, $controlTowerId: String!) {
    getCollaboratorByUserIdAndControlTowerId(userId: $userId, controlTowerId: $controlTowerId) {
      _id
      collaboratorType
      controlTowerId
      email
      firstName
      lastName
      userId
      scopes

    }
  }
`;

export const IS_COLLABORATOR_OF_CONTROL_TOWER_BY_USER_ID_AND_CONTROL_TOWER_ID = `
  query IsCollaboratorOfControlTowerByUserIdAndControlTowerId($userId: String!, $controlTowerId: String!) {
    isCollaboratorOfControlTowerByUserIdAndControlTowerId(userId: $userId, controlTowerId: $controlTowerId)
  }
`;

export const FIND_ORG_USER_WITH_SCOPES_BY_INDIVIDUAL_ID = `
  query GetControlTowerOrgUserWithScopesByIndividualId($individualId: String!) {
    getControlTowerOrgUserWithScopesByIndividualId(individualId: $individualId)
  }
`;

export const UPDATE_COLLABORATOR_FEATURE_MARKETING_META_DATA = `mutation UpdateCollaboratorFeatureMarketingMetaData($collaboratorId: String!, $featureMarketingMetaData: FeatureMarketingMetaDataInput!) {
  updateCollaboratorFeatureMarketingMetaData(collaboratorId: $collaboratorId, featureMarketingMetaData: $featureMarketingMetaData) {
      _id
      collaboratorType
      controlTowerId
      email
      firstName
      lastName
      userId
      scopes
      featureMarketingMetaData {
      isCTAcompleted
    }
  }
}`;
